<template>
  <wrapper>
    <section class="add-challenge-partner-page">
      <div class="row">
        <div class="col-md-8 col-md-offset-2">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">Add Partner</h3>
            </div>
            <div class="box-body">
              <challenge-partner-form
                :value="form"
                :is-loading="isSaving"
                submit-label="Create Partner"
                @validated="handleSubmit"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper';
import ChallengePartnerForm from '@/components/forms/ChallengePartnerForm';

export default {
  name: 'AddChallengePartner',
  components: { Wrapper, ChallengePartnerForm },
  data() {
    return {
      form: {
        name: '',
        slug: '',
        category: 'general',
        links_to: [],
        parent_id: null,
        contact_email: '',
        logo_filename: '',
        website: '',
        logoFile: null,
      },
      isSaving: false,
    };
  },
  computed: {
    challengeSlug() {
      return this.$route.params.challengeSlug;
    },
  },
  mounted() {
    if (this.$route.query.parent) {
      this.$store.dispatch('challenges/getChallengePartners', this.challengeSlug).then((partners) => {
        const parent = partners.find((p) => p.slug === this.$route.query.parent);
        if (parent) {
          this.form.parent_id = parent.id;
          this.form.category = parent.category;
          this.form.links_to = [...parent.links_to];
        }
      });
    }
  },
  methods: {
    handleSubmit(formData) {
      this.isSaving = true;
      const data = new FormData();
      data.append('name', formData.name);
      data.append('category', formData.category);
      (formData.links_to || []).forEach((value) => data.append('links_to[]', value));
      if (formData.slug) data.append('slug', formData.slug);
      if (formData.contact_email) data.append('contact_email', formData.contact_email);
      if (formData.logo_filename) data.append('logo_filename', formData.logo_filename);
      if (formData.website) data.append('website', formData.website);
      if (formData.parent_id !== null) data.append('parent_id', formData.parent_id);
      if (formData.logoFile) data.append('logo', formData.logoFile);

      const payload = { challengeSlug: this.challengeSlug, data };

      this.$store.dispatch('challenges/createChallengePartner', payload).then((partner) => {
        this.$router.replace(`/challenges/${this.challengeSlug}/partners/${partner.slug}`);
      }).catch((err) => {
        this.$apiResponse.renderErrorMessage(err);
      }).finally(() => {
        this.isSaving = false;
      });
    },
  },
};
</script>
